import Footer from "@Components/Footer/Footer";
import Header from "@Components/Header/Header";
import { AppRoutes } from "@Src/routes/Routes";
import { ReactNode } from "react";
import { MobHeader } from "@Components/Mob-header/Mob-header";
import './HomeLayout.scss'
interface Props {
    children?: ReactNode
    // any props that come into the component
}

const HomeLayout = ({children}: Props) => {
    return (
<>
<div className="tw-min-h-screen tw-flex tw-flex-col">
    <Header />
    <MobHeader/>
    <div className="main-layout-container tw-flex-grow">
    {children}
    </div>
    <Footer />
</div>
</>
    );
};

export default HomeLayout;
